<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="编辑一级标签"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="650px"
        append-to-body
        :before-close="handleClose">
        <div class="content-wrap pr20 mt20">
            <el-form ref="form" :model="formItem" :rules="rules" label-width="150px">
                <el-form-item label="标签归属：">
                    <span>{{data.dimension_name||'--'}}</span>
                </el-form-item>
                <el-form-item label="标签名称：">
                    <span>{{data.name||'--'}}</span>
                </el-form-item>
                <el-form-item label="最多可设置数量：" prop="max_allow_num" class="label-required">
                    <el-input-number v-model="formItem.max_allow_num" :min="1" :max="99" label="最多可设置数量"></el-input-number>
                    <p class="mt10 text-color-gray font12px">其子标签在设置时最多可同时设置的子标签数量，若是单选请设置“1”</p>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/baseInfo/tag.js';

    export default {
        name: "EidtLevel1TagModal",
        props:{
            data:Object,
        },
        data(){
            return {
                dialogVisible:false,
                formItem:{
                    max_allow_num:1,
                },
                rules:{
                    max_allow_num:[
                        { required: true, message: '最多可设置数量不能为空',trigger:'change'},
                        { type: 'number', message: '最多可设置数量必须为数字值',trigger:'change'}
                    ],
                },
                submitLoading:false,
            };
        },
        methods:{
            handleClose(){
                this.dialogVisible = false;
            },
            showModal(){
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    this.formItem.max_allow_num = this.data.max_allow_num;
                })
            },
            handleSubmit(){
                console.log('handleSubmit');
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.submitLoading = true;
                        API.editLevel1Tag({
                            id:this.data.id,
                            max_allow_num:this.formItem.max_allow_num,
                        }).then(res=>{
                            console.log('editLevel1Tag',res);
                            this.submitLoading = false;
                            this.handleClose();
                            this.$emit('update',this.formItem.max_allow_num);
                        },err=>{
                            console.log('editLevel1Tag err',err);
                            this.submitLoading = false;
                            this.$message.error(err.info||'操作失败');
                        })
                    } else {
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>
